import COLORS from 'pared/constants/colors'

import { IConfigsType } from '../../types'

const fwWingstopFinancialChartConfig: IConfigsType = {
  'fw_wingstop-financial-chart-239cbabf': {
    '/:brand/sales_chart': {
      variables: [
        'date',
        'farwestTimeinterval',
        {
          type: 'selectOptions',
          options: {
            orderMode: {
              defaultId: [['net_sales']],
              options: [
                { id: 'net_sales', displayName: 'Total' },
                {
                  id: 'olo_take_out',
                  displayName: 'Online (Pick Up)',
                },
                {
                  id: 'online_dispatch_sales',
                  displayName: 'Online (Dispatch)',
                },
                {
                  id: 'walk_in_dine_in',
                  displayName: 'Dine In - Walk In',
                },
                {
                  id: 'walk_in_to_go',
                  displayName: 'Take Out - Walk In',
                },
                {
                  id: 'sales_take_out_call_in_call_center',
                  displayName: 'Take Out - Call in/Call Center',
                },
              ],
            },
          },
        },
      ],
      groupFilter: {
        api: 'fwWingstopCorporateWithoutBreakdownFilter',
      },
      dateFilter: {
        types: ['year'],
        defaultType: 'year',
      },
      pageTitle: {
        type: 'title',
        title: 'Total Sales Charts',
      },
      salesChartFilters: {
        type: 'grid',
        children: {
          downloadReport: {
            type: 'download-csv',
            api: 'farwestSalesCharts',
            fileName: 'getexpo-far-west-sales-charts',
            message: 'Download as CSV',
            fields: [
              {
                key: 'period',
                title: 'Date Period - Metric',
              },
              {
                key: 'currentValue',
                title: 'Data for <%- date?.getInfo(0)?.displayName %>',
              },
              {
                key: 'lastYearValue',
                title:
                  'Data for <%- (parseInt(date?.getInfo(0)?.displayName) - 1).toString() %>',
              },
            ],
          },
          timeColumns: {
            type: 'select',
            value: 'farwestTimeinterval.value',
            onChange: 'farwestTimeinterval.onChange',
            options: 'farwestTimeinterval.options',
            label: 'Time Interval:',
          },
          revenueColumns: {
            type: 'select',
            value: 'selectOptions.orderMode.value',
            onChange: 'selectOptions.orderMode.onChange',
            options: 'selectOptions.orderMode.options',
            label: 'Channel:',
          },
        },
      },
      salesChart: {
        type: 'bar-chart',
        api: 'farwestSales',
        width: 1500,
        height: 800,
        label: 'period',
        datasets: [
          {
            chartType: 'line',
            key: 'value',
            label: 'Current Year Sales',
            borderColor: COLORS.Basil,
            backgroundColor: COLORS.Basil,
          },
          {
            key: 'valueLastYear',
            label: 'Prior Year Sales',
            borderColor: COLORS.Plum,
            backgroundColor: COLORS.Plum,
          },
        ],
        scaleTypes: {
          y: {
            type: 'price',
            beginAtZero: true,
          },
        },
        options: {
          scales: {
            x: {
              ticks: {
                font: {
                  size: 10,
                },
              },
            },
          },
        },
      },
    },
    '/:brand/sss_chart': {
      variables: [
        'date',
        'farwestTimeinterval',
        {
          type: 'selectOptions',
          options: {
            orderMode: {
              defaultId: [['net_sales']],
              options: [
                { id: 'net_sales', displayName: 'SSS%' },
                { id: 'check_count', displayName: 'SST%' },
                {
                  id: 'check_average',
                  displayName: 'SSC%',
                },
              ],
            },
          },
        },
      ],
      groupFilter: {
        api: 'fwWingstopCorporateWithoutBreakdownFilter',
      },
      dateFilter: {
        types: ['year'],
        defaultType: 'year',
      },
      pageTitle: {
        type: 'title',
        title: 'SSS/SST/SSC Charts',
        subTitle: [
          'In the current time frame, Prior Year and 2 Years prior show values for the entire time frame;',
          'but the 1 Year, 2 Years Stacked and 3 Years Stacked show values for the current time frame to date',
        ],
      },
      salesChartFilters: {
        type: 'grid',
        children: {
          downloadReport: {
            type: 'download-csv',
            api: 'farwestSssCharts',
            fileName: 'getexpo-far-west-sss-sst-ssc-charts',
            message: 'Download as CSV',
            fields: [
              {
                key: 'period',
                title: 'Date Period - Metric',
              },
              {
                key: 'currentValue',
                title: '1Y Data for <%- date?.getInfo(0)?.displayName %>',
                decimal: 4,
              },
              {
                key: 'twoYearsStackedValue',
                title:
                  '2Y Stacked Data for <%- date?.getInfo(0)?.displayName %>',
                decimal: 4,
              },
              {
                key: 'threeYearsStackedValue',
                title:
                  '3Y Stacked Data for <%- date?.getInfo(0)?.displayName %>',
                decimal: 4,
              },
              {
                key: 'lastYearValue',
                title:
                  'Data for <%- (parseInt(date?.getInfo(0)?.displayName) - 1).toString() %>',
                decimal: 4,
              },
              {
                key: 'twoYearsAgoValue',
                title:
                  'Data for <%- (parseInt(date?.getInfo(0)?.displayName) - 2).toString() %>',
                decimal: 4,
              },
            ],
          },
          timeColumns: {
            type: 'select',
            value: 'farwestTimeinterval.value',
            onChange: 'farwestTimeinterval.onChange',
            options: 'farwestTimeinterval.options',
            label: 'Time Interval:',
          },
          revenueColumns: {
            type: 'select',
            value: 'selectOptions.orderMode.value',
            onChange: 'selectOptions.orderMode.onChange',
            options: 'selectOptions.orderMode.options',
            label: 'Channel:',
          },
        },
      },
      sssChart: {
        type: 'bar-chart',
        api: 'farwestSss',
        width: 1500,
        height: 800,
        label: 'period',
        datasets: [
          {
            chartType: 'line',
            key: 'value',
            label: '1 Year',
            borderColor: COLORS.Basil,
            backgroundColor: COLORS.Basil,
          },
          {
            chartType: 'line',
            key: 'valueTwoYearsStacked',
            label: '2 Years Stacked',
            borderColor: COLORS.ExpoRed1,
            backgroundColor: COLORS.ExpoRed1,
          },
          {
            chartType: 'line',
            key: 'valueThreeYearsStacked',
            label: '3 Years Stacked',
            borderColor: COLORS.Mango,
            backgroundColor: COLORS.Mango,
            hidden: true,
          },
          {
            key: 'valueLastYear',
            label: 'Prior Year',
            borderColor: COLORS.Plum,
            backgroundColor: COLORS.Plum,
          },
          {
            key: 'valueTwoYearsAgo',
            label: '2 Years Prior',
            borderColor: COLORS.Sky,
            backgroundColor: COLORS.Sky,
            hidden: true,
          },
        ],
        scaleTypes: {
          y: {
            type: 'percent',
            beginAtZero: true,
          },
        },
        options: {
          scales: {
            x: {
              ticks: {
                font: {
                  size: 10,
                },
              },
            },
          },
        },
      },
    },
    '/:brand/check_average_chart': {
      variables: [
        'date',
        'farwestTimeinterval',
        {
          type: 'selectOptions',
          options: {
            orderMode: {
              defaultId: [['check_average']],
              options: [{ id: 'check_average', displayName: 'Total' }],
            },
          },
        },
      ],
      groupFilter: {
        api: 'fwWingstopCorporateWithoutBreakdownFilter',
      },
      dateFilter: {
        types: ['year'],
        defaultType: 'year',
      },
      pageTitle: {
        type: 'title',
        title: 'Check Average Charts',
      },
      checkAverageChartFilters: {
        type: 'grid',
        children: {
          downloadReport: {
            type: 'download-csv',
            api: 'farwestCheckAverageCharts',
            fileName: 'getexpo-far-west-check-average-charts',
            message: 'Download as CSV',
            fields: [
              {
                key: 'period',
                title: 'Date Period - Metric',
              },
              {
                key: 'currentValue',
                title: 'Data for <%- date?.getInfo(0)?.displayName %>',
              },
              {
                key: 'lastYearValue',
                title:
                  'Data for <%- (parseInt(date?.getInfo(0)?.displayName) - 1).toString() %>',
              },
            ],
          },
          timeColumns: {
            type: 'select',
            value: 'farwestTimeinterval.value',
            onChange: 'farwestTimeinterval.onChange',
            options: 'farwestTimeinterval.options',
            label: 'Time Interval:',
          },
          revenueColumns: {
            type: 'select',
            value: 'selectOptions.orderMode.value',
            onChange: 'selectOptions.orderMode.onChange',
            options: 'selectOptions.orderMode.options',
            label: 'Channel:',
          },
        },
      },
      checkAverageChart: {
        type: 'bar-chart',
        api: 'farwestCheckAverage',
        width: 1500,
        height: 800,
        label: 'period',
        datasets: [
          {
            chartType: 'line',
            key: 'value',
            label: 'Current Year Check Average',
            decimal: 2,
            borderColor: COLORS.Basil,
            backgroundColor: COLORS.Basil,
          },
          {
            key: 'valueLastYear',
            label: 'Prior Year Check Average',
            decimal: 2,
            borderColor: COLORS.Plum,
            backgroundColor: COLORS.Plum,
          },
        ],
        scaleTypes: {
          y: {
            type: 'price',
            decimal: 2,
            min: 1500,
          },
        },
        options: {
          scales: {
            x: {
              ticks: {
                font: {
                  size: 10,
                },
              },
            },
          },
        },
      },
    },
  },
}

export default fwWingstopFinancialChartConfig
